/* eslint-disable no-console */
import { Switch } from "@material-ui/core";

export const PrintTwoBaseMaps = ({ enabledPrintTwoBasemaps, handlePrintTwoBasemaps }) => {

    // return (
    //     <FormControlLabel
    //         control={<Switch checked={enabledPrintTwoBasemaps} color='primary' onChange={handlePrintTwoBasemaps} />}
    //         label="Análise temporal"
    //         labelPlacement="end"
    //         style={{ whiteSpace: 'nowrap'}}
    //     />
    // );
    return (
    <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
      <span style={{ paddingLeft: '10px' }}>Análise temporal</span>
      <Switch
        checked={enabledPrintTwoBasemaps}
        color="primary"
        onChange={handlePrintTwoBasemaps}
      />
    </div>
  );
};

PrintTwoBaseMaps.properties = {
    id: 'CPN-TB-RA-SIDE-BY-SIDE-PRINT',
    alias: 'Impressão Antes e Depois',
    description: 'Possibilita a impressao do mapa com comparação de mosaicos de diferentes datas da Planet.',
};

export default PrintTwoBaseMaps;
